import React, { FC } from 'react';
import Form from 'components/Form';

import { TransactPageProps } from './models';

import 'styles/main.scss';
import './styles.scss';

const Transact: FC<TransactPageProps> = ({ pageContext, location }) => (
  <Form {...{ ...pageContext, location }} />
);

export default Transact;
